import React, { useCallback } from 'react';

import { VOID_FUNCTION } from 'constants/index';

import { BUTTON_TEXT } from './Button.constants';
import * as S from './Button.styles';

export const Button = ({
  active,
  dataTest,
  type,
  onClick: onClickProp = VOID_FUNCTION,
  ...rest
}) => {
  const onClick = useCallback(
    (event) => {
      onClickProp(event, { type });
    },
    [onClickProp, type]
  );

  return (
    <S.Button {...rest} active={active} dataTest={dataTest} size="s" onClick={onClick}>
      {BUTTON_TEXT[type]}
    </S.Button>
  );
};
